import axios from 'axios'
import history from 'router/history'
import Session from 'classes/Session'

export function logout() {
  Session.logout()
  axios.defaults.headers.common['Authorization'] = undefined
  history.push('/auth/login-page')
}
